import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';
import {AddCircleOutline as AddCircleOutlineIcon} from 'views/icons';
import {Translate} from 'views/module';


import RelationshipNew from './RelationshipNew';
import RelationshipView from './RelationshipView';
import RelationshipEdit from './RelationshipEdit';

const RelationshipList = (props) => {
  const [model, setModel] = React.useState({});

  const clientData = props.clientData;
  const clientAuthentication = props.clientAuthentication;
  const clientBackend = props.clientBackend;
  const relationships = clientData.relationships;
  const clientNotification = props.clientNotification;

  const openDialogs = {
    close: () => {
      setModel({});
    },
    addRelationship: () => {
      setModel({action: 'ADD_RELATIONSHIP'});
    },
    editRelationship: (relationship) => {
      setModel({action: 'EDIT_RELATIONSHIP', relationship});
    },
  };

  const edits = {
    add: (relationship) => {
      const complete = () => {
        setModel({});
      };

      const input = {
        name: relationship.name,
        connectionType: relationship.connectionType,
        priority: relationship.priority,
        description: relationship.description,
        contacts: relationship.contacts.filter((e) => e.type && e.detail),
      };
      clientBackend.detail.relationship.add(input, complete);
    },
    edit: (relationshipRn, relationship) => {
      const complete = () => {
        setModel({});
      };

      const input = {
        name: relationship.name,
        connectionType: relationship.connectionType,
        priority: relationship.priority,
        description: relationship.description,
        contacts: relationship.contacts.filter((e) => e.type && e.detail),
      };
      clientBackend.detail.relationship.edit(relationshipRn, input, complete);
    },
    remove: (relationshipRn) => {
      const complete = () => {
        setModel({});
      };

      clientBackend.detail.relationship.remove(relationshipRn, complete);
    },
  };

  const popModelGenerator = React.useCallback(() => {
    let popModel = null;
    if (model.action === 'ADD_RELATIONSHIP') {
      popModel = <RelationshipNew
        onClose={openDialogs.close}
        addRelationship={edits.add}
      />;
    } else if (model.action === 'EDIT_RELATIONSHIP') {
      popModel = <RelationshipEdit
        onClose={openDialogs.close}
        editRelationship={edits.edit}
        relationship={model.relationship}
      />;
    }
    return popModel;
  }, [model]);


  const calculateRelationships = React.useCallback(() => {
    return Object.values(relationships).sort((a, b) => a.priority - b.priority);
  }, [relationships]);

  const relationshipView = calculateRelationships();

  return (
    <Stack
      sx={{
      }}
    >
      {popModelGenerator()}
      {
        relationshipView.map((e, index) => {
          const userIdentity = clientAuthentication[e.relationshipRn];
          const userNotificationEmail = clientNotification[e.relationshipRn];
          return (
            <RelationshipView
              key={index}
              relationshipData={e}
              removeRelationship={edits.remove}
              editRelationship={openDialogs.editRelationship}
              clientBackend={clientBackend}
              userIdentity={userIdentity}
              userNotificationEmail={userNotificationEmail}
              clientAuthenticationLoading={clientAuthentication[e.relationshipRn] === undefined}
              clientNotificationLoading={userNotificationEmail === undefined}
            />
          );
        })
      }
      <Button
        startIcon={<AddCircleOutlineIcon />}
        onClick={openDialogs.addRelationship}
        sx={{
          mx: 2,
          my: 1,
        }}
      >
        <Translate expression='client.ClientDetail.Relationships.AddRelationship' />
      </Button>
    </Stack>
  );
};

RelationshipList.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
  clientAuthentication: PropTypes.object.isRequired,
  clientNotification: PropTypes.objectOf(PropTypes.string).isRequired,
};
export default React.memo(RelationshipList);
